import { STORE_BUNDLE_MERCHANTS_GET_SUCCESS, STORE_BUNDLE_MERCHANTS_GET_FAILURE } from '../actions/types';

const initialState = {
  defaults: {
    isLoaded: false,
    isLoading: false,
    merchants: [],
  },
};

export default (state = initialState, action) => {
  const namespace = action?.options?.namespace || action?.context?.options?.namespace || 'default';
  const { defaults } = state;
  const { [namespace]: namespaceState = defaults } = state;

  switch (action.type) {
    case STORE_BUNDLE_MERCHANTS_GET_SUCCESS: {
      const { response = [] } = action.payload;
      const merchants = response.map(({ merchant }) => merchant);

      return {
        ...state,
        [`namespace-${namespace}`]: {
          ...namespaceState,
          merchants,
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    case STORE_BUNDLE_MERCHANTS_GET_FAILURE: {
      return {
        ...state,
        [`namespace-${namespace}`]: {
          ...namespaceState,
          merchants: [],
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    default: {
      const { options = {} } = action;
      if (options.success === STORE_BUNDLE_MERCHANTS_GET_SUCCESS) {
        return {
          ...state,
          [`namespace-${namespace}`]: {
            ...namespaceState,
            isLoading: true,
          },
        };
      }

      return state;
    }
  }
};
